import {TOGGLE_FILTERS} from "../../actions/toggleFilters";

export default function (state = false, action = '') {
    if (action.type === TOGGLE_FILTERS) {
        return !state;
    }

    return state;
}